import React from "react";

const Clock = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1917 14.3083L13.475 13.025L10.0833 9.63334V5.41668H8.25V10.3667L12.1917 14.3083ZM9.16667 19.1667C7.89861 19.1667 6.70694 18.9261 5.59167 18.4448C4.47639 17.9636 3.50625 17.3104 2.68125 16.4854C1.85625 15.6604 1.20313 14.6903 0.721875 13.575C0.240625 12.4597 0 11.2681 0 10C0 8.73195 0.240625 7.54029 0.721875 6.42501C1.20313 5.30973 1.85625 4.33959 2.68125 3.51459C3.50625 2.68959 4.47639 2.03647 5.59167 1.55522C6.70694 1.07397 7.89861 0.833344 9.16667 0.833344C10.4347 0.833344 11.6264 1.07397 12.7417 1.55522C13.8569 2.03647 14.8271 2.68959 15.6521 3.51459C16.4771 4.33959 17.1302 5.30973 17.6115 6.42501C18.0927 7.54029 18.3333 8.73195 18.3333 10C18.3333 11.2681 18.0927 12.4597 17.6115 13.575C17.1302 14.6903 16.4771 15.6604 15.6521 16.4854C14.8271 17.3104 13.8569 17.9636 12.7417 18.4448C11.6264 18.9261 10.4347 19.1667 9.16667 19.1667ZM9.16667 17.3333C11.1986 17.3333 12.9288 16.6191 14.3573 15.1906C15.7858 13.7622 16.5 12.032 16.5 10C16.5 7.96807 15.7858 6.23786 14.3573 4.80939C12.9288 3.38091 11.1986 2.66668 9.16667 2.66668C7.13472 2.66668 5.40451 3.38091 3.97604 4.80939C2.54757 6.23786 1.83333 7.96807 1.83333 10C1.83333 12.032 2.54757 13.7622 3.97604 15.1906C5.40451 16.6191 7.13472 17.3333 9.16667 17.3333Z"
      fill={color}
    />
  </svg>
);

Clock.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Clock;
